import qs from 'query-string';
import { createSelector } from 'reselect';

import { createSelectorFactory } from 'wanderu-ducks-utils';

import {
    getFilterQueryParams,
} from '../filterData/filterUtils';

function _selectUrlDirection(props) {
    return props.match.params.direction;
}

function _selectUrlOriginText(props) {
    return decodeURIComponent(props.match.params.originText);
}

function _selectUrlDestinationText(props) {
    return decodeURIComponent(props.match.params.destinationText);
}

function _selectUrlDepartDate(props) {
    return props.match.params.departDate;
}

function _selectUrlReturnDate(props) {
    return props.match.params.returnDate;
}

function _selectQuery(props) {
    return props.location.search;
}

const _selectParsedQuery = createSelector(
    _selectQuery,
    (query) => typeof query === 'string'
        ? qs.parse(query)
        : query,
);

const _selectUrlOrignPlaceId = createSelector(
    _selectParsedQuery,
    (parsedQuery) => parsedQuery.opid,
);

const _selectUrlDestinationPlaceId = createSelector(
    _selectParsedQuery,
    (parsedQuery) => parsedQuery.dpid,
);

const _selectUrlDepartTripId = createSelector(
    _selectParsedQuery,
    (parsedQuery) => parsedQuery.dtid,
);

const selectUrlSearchParams = createSelector(
    _selectUrlDirection,
    _selectUrlOriginText,
    _selectUrlOrignPlaceId,
    _selectUrlDestinationText,
    _selectUrlDestinationPlaceId,
    _selectUrlDepartDate,
    _selectUrlReturnDate,
    _selectUrlDepartTripId,
    (...params) => ({
        direction: params[0],
        originText: params[1],
        originPlaceId: params[2],
        destinationText: params[3],
        destinationPlaceId: params[4],
        departDate: params[5],
        returnDate: params[6],
        departTripId: params[7],
    }),
);

function _selectSearch(props) {
    return props.location.search;
}

function selectUrlFilterParamsFactory(direction) {
    return createSelector(
        _selectSearch,
        () => direction,
        getFilterQueryParams,
    );
}

const selectUrlFilterParams = createSelectorFactory(selectUrlFilterParamsFactory);

export {
    selectUrlFilterParams,
    selectUrlSearchParams,
};
